import React from 'react';
import './warranty-center.css';
import Modal, { IModalChildProps } from '../../common/modal';
import { useIntl } from 'react-intl';

const SecondConsentModal = ({ onClose }: IModalChildProps) => {
    const intl = useIntl();
    return (
        <Modal>
            <>
                <div className="modal-content">
                    <div className="modal-header consent-header">
                        <h4 className="modal-title">
                            {intl.formatMessage({
                                id: 'GDPR_NoConsent_Modal',
                                defaultMessage: `You need consent before proceeding.`,
                            })}
                        </h4>
                    </div>

                    <div className="modal-footer consent-footer">
                        <button
                            type="button"
                            className="consent-button"
                            onClick={onClose}
                        >
                            {intl.formatMessage({
                                id: 'OK',
                                defaultMessage: 'OK',
                            })}
                        </button>
                    </div>
                </div>
            </>
        </Modal>
    );
};

export default SecondConsentModal;
